var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget widget-primary widget-inner" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h1", { staticClass: "mb-5 mt-5" }, [
          _vm._v(_vm._s(_vm.$translate("Phywe::Template.manSearchTitle")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _c(
          "div",
          { staticClass: "grey-box " },
          [
            _c("h3", [
              _vm._v(_vm._s(_vm.$translate("Phywe::Template.manSearchDesc")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-unit mt-4" }, [
              _c("input", {
                attrs: {
                  type: "text",
                  name: "quickbuy",
                  id: "quickbuy",
                  autocomplete: "quickbuy"
                },
                on: {
                  keyup: function($event) {
                    return _vm.searchItems($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "quickbuy" } }, [
                _vm._v(_vm._s(_vm.$translate("Phywe::Template.manArtikelNr")))
              ])
            ]),
            _vm._v(" "),
            _vm.textSearch.length > 0
              ? [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$translate("Phywe::Template.manSearchMeaning"))
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.textSearch, function(item) {
                    return _c(
                      "div",
                      {
                        staticClass: "basket-list-item py-3",
                        on: {
                          click: function($event) {
                            return _vm.searchSingleItem(item)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "basket-item component-loading with-icon d-flex"
                          },
                          [
                            _c("div", { staticClass: "image-container" }, [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: item.image }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "meta-container-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "meta-container-wrapper-inner"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "meta-container" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "position-relative w-100"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted small"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.beforeLabel) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "item-name text-primary text-appearance small font-weight-bold text-break",
                                                attrs: { href: "#" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.label) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-7 mt-2 mt-lg-0" }, [
        _c("div", { staticClass: "grey-box" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.$translate("Phywe::Template.manSearchFoundDocs")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.loading === true
                ? [_vm._m(0)]
                : [
                    _vm.foundItems.length == 0
                      ? _c("ul", [
                          _c("li", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.manSearchNoResult"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.foundItems.length > 0
                      ? _c(
                          "ul",
                          { staticClass: "list-inline filterbuttons mt-3" },
                          [
                            _vm.fileTypes.all > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item ",
                                      class: { active: _vm.showFiles == "all" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("all")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.alleFilter"
                                          )
                                        ) +
                                          " (" +
                                          _vm._s(_vm.fileTypes.all) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fileTypes.pdf > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item",
                                      class: { active: _vm.showFiles == "pdf" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("pdf")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "pdf (" +
                                          _vm._s(_vm.fileTypes.pdf) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fileTypes.exe > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item",
                                      class: { active: _vm.showFiles == "exe" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("exe")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "exe (" +
                                          _vm._s(_vm.fileTypes.exe) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fileTypes.dmg > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item",
                                      class: { active: _vm.showFiles == "dmg" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("dmg")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "dmg (" +
                                          _vm._s(_vm.fileTypes.dmg) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fileTypes.msi > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item",
                                      class: { active: _vm.showFiles == "msi" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("msi")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "msi (" +
                                          _vm._s(_vm.fileTypes.msi) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.fileTypes.pkg > 0
                              ? [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "list-inline-item",
                                      class: { active: _vm.showFiles == "pkg" },
                                      on: {
                                        click: function($event) {
                                          return _vm.switchShowFiles("pkg")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "pkg (" +
                                          _vm._s(_vm.fileTypes.pkg) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.foundItems.length > 0
                      ? [
                          _c("div", { staticClass: "card-body px-0" }, [
                            _c("div", { staticClass: "widget-listforitems" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "row mt-0 mb-4 d-none d-lg-flex"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-lg-7" },
                                    [_vm._v(" ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-none d-lg-block col-lg-1"
                                    },
                                    [_vm._v(" ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-none d-lg-block col-lg-2"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.sbindingTableCell3"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-none d-lg-block col-lg-2 text-center"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.sbindingTableCell5"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "itemslist" },
                                [
                                  _vm._l(_vm.foundItems, function(media) {
                                    return _vm.showFiles ==
                                      media.fileExtension ||
                                      _vm.showFiles == "all"
                                      ? [
                                          media.fileExtension == "exe" ||
                                          media.fileExtension == "msi" ||
                                          media.fileExtension == "pkg" ||
                                          media.fileExtension == "dmg"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row itemblocks mt-3"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-10 col-lg-9 order-0 order-lg-0"
                                                      },
                                                      [
                                                        _c("a", {
                                                          staticClass: "cursor",
                                                          attrs: {
                                                            href:
                                                              media.fileInternalComment,
                                                            target: "_blank"
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              media.fileExternalComment
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 col-lg-2 order-2 order-lg-1"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-lg-none text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Phywe::Template.sbindingTableCell3"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center"
                                                      },
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              media.fileExtension
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row itemblocks mt-3"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-10 col-lg-8 order-0 order-lg-0"
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass: "cursor",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              media.realName
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.getFileContent(
                                                                media.id
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 col-lg-2 order-2 order-lg-1"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-lg-none text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Phywe::Template.sbindingTableCell3"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              (
                                                                media.fileSize /
                                                                1000000
                                                              ).toFixed(2)
                                                            ) + " Mb"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-none d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-center"
                                                      },
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              media.fileExtension
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                        ]
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ]
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }